import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import YearSelect from '../../../../helpers/ui/YearSelect'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Redirect, Link } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import CustomSelect from '../../GlobalComponents/CustomSelect'
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

import AwardBloc from '../Index/Blocs/AwardBloc'
import CreateBloc from './Blocs/CreateBloc'

// let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
// if(accessRole('approve')){
//     peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
// }

var reformatPeriodeAward = function(award) {
    return award.map((value, index) => {
        var newObj = {};
        newObj['label'] = value.award_period_year
        newObj['value'] = value.award_period_uuid

        return newObj;
    })
};
var reformatOptionAward = function(award) {
    return award.map((value, index) => {
        var newObj = {};
        newObj['label'] = value.type_of_award_name
        newObj['value'] = value.type_of_award_uuid

        return newObj;
    })
};

var reformatOptionSignatories = function(signatories) {
    return signatories.map((value, index) => {
        var newObj = {};
        newObj['label'] = `${value.signatories_official_name} - ${value.signatories_official_position}` 
        newObj['value'] = value.signatories_official_uuid

        return newObj;
    })
};

class CreateView extends Component {
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    source
    awardBloc = new AwardBloc()
    createBloc = new CreateBloc()
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            awardOption: [],
            periodeOption: [],
            signatoriesOption: [],
            periodeFilter: {
                            filter_value: "",
                            page_number: 1,
                            page_size: this.defaultSize,
                            sort_order: {
                                column: 'award_period_year',
                                order: 'asc' 
                            }
                        },
            awardFilter: {
                            filter_value: "",
                            page_number: 1,
                            page_size: this.defaultSize,
                            sort_order: {
                                column: 'type_of_award_name',
                                order: 'asc' 
                            }
                        },
            signatoriesFilter: {
                            filter_value: "",
                            page_number: 1,
                            page_size: this.defaultSize,
                            sort_order: {
                                column: 'signatories_official_name',
                                order: 'asc' 
                            }
                        }
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'document')
        await this.createBloc.fetchCreate(dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    loadAwardPeriode = async () => {
        let offset = (this.state.periodeFilter.page_number-1)*this.state.periodeFilter.page_size
        const query = {
            search: this.state.periodeFilter.filter_value,
            limit: this.state.periodeFilter.page_size,
            offset: offset,
            order: this.state.periodeFilter.sort_order.column,
            sort: this.state.periodeFilter.sort_order.order,
            status: 1
        }
        await this.awardBloc.fetchPeriode(query, this.source.token)
    }
    loadAwardType = async () => {
        let offset = (this.state.awardFilter.page_number-1)*this.state.awardFilter.page_size
        const query = {
            search: this.state.awardFilter.filter_value,
            limit: this.state.awardFilter.page_size,
            offset: offset,
            order: this.state.awardFilter.sort_order.column,
            sort: this.state.awardFilter.sort_order.order,
            status: 1
        }
        await this.awardBloc.fetchType(query, this.source.token)
    }

    loadAwardSignatories = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.awardBloc.fetchSignatories(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadAwardPeriode()
        this.loadAwardType()
        this.loadAwardSignatories()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.awardBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ awardOption: reformatOptionAward(result.data.response.result) })    
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        
        this.awardBloc.periodeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ periodeOption: reformatPeriodeAward(result.data.response.result) })    
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.awardBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: reformatOptionSignatories(result.data.response.result) })
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel.unsubscribe()
        this.awardBloc.periodeChannel?.unsubscribe()
        this.awardBloc.typeChannel?.unsubscribe()
        this.awardBloc.signatoriesFilter?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <PegawaiSideBar active="penghargaan" />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?penghargaan`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Tambah Data Penghargaan</CardTitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                       <Row className="mb-3">
                                            <Label htmlFor="award_award_period_uuid" className="col-md-3 col-form-label">Periode Penghargaan <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="award_award_period_uuid"
                                                    errorMessage="Pilih Periode Penghargaan"
                                                    options={this.state.periodeOption} 
                                                    placeholder="Pilih Periode Penghargaan"
                                                />
                                            </Col>
                                        </Row>
                                       <Row className="mb-3">
                                            <Label htmlFor="fieldAward" className="col-md-3 col-form-label">Jenis Penghargaan <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="award_type_of_award_uuid"
                                                    errorMessage="Pilih Jenis Penghargaan"
                                                    options={this.state.awardOption} 
                                                    placeholder="Pilih Jenis Penghargaan"
                                                />
                                            </Col>
                                        </Row>
                                       <Row className="mb-3">
                                            <Label htmlFor="award_title" className="col-md-3 col-form-label">Nama Penghargaan <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <AvField 
                                                    name="award_title"
                                                    placeholder="Nama Penghargaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Penghargaan"
                                                    className="form-control"
                                                    id="award_title"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                       <Row className="mb-3">
                                            <Label htmlFor="award_year" className="col-md-3 col-form-label">Tahun <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <AvField 
                                                    name="award_year"
                                                    placeholder="Tahun..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Tahun (4 digit)"
                                                    className="form-control"
                                                    id="award_year"
                                                    // validate={{ 
                                                    //     required: { value: true },
                                                    //     pattern: { value: '^[0-9]{4}$', errorMessage: "Tahun harus 4 digit" }
                                                    // }}
                                                />
                                            </Col>
                                        </Row>
                                       <Row className="mb-3">
                                            <Label htmlFor="fieldSKNumber" className="col-md-3 col-form-label">No. SK <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <AvField 
                                                    name="award_decree_number"
                                                    placeholder="No. SK..."
                                                    type="text"
                                                    errorMessage="Masukkan No. SK"
                                                    className="form-control"
                                                    id="fieldSKNumber"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label htmlFor="award_decree_date" className="col-md-3 col-form-label">Tanggal SK <span className="text-danger">*</span></Label>
                                            <Col md="3">
                                                <AvField 
                                                    name="award_decree_date"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal SK"
                                                    className="form-control"
                                                    id="award_decree_date"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label htmlFor="award_signatories_official" className="col-md-3 col-form-label">Pemberi Penghargaan <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <AvField 
                                                    name="award_signatories_official"
                                                    placeholder="Pejabat Penetap..."
                                                    type="text"
                                                    errorMessage="Masukkan Pejabat Penetap"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        {/* <Row className="mb-3">
                                            <Label htmlFor="fieldAward" className="col-md-3 col-form-label">Penandatangan <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="awardType"
                                                    errorMessage="Pilih Penandatangan"
                                                    options={this.state.signatoriesOption} 
                                                    placeholder="Pilih Penandatangan"
                                                />
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <Label htmlFor="award_description" className="col-md-3 col-form-label">Deskripsi </Label>
                                            <Col md="6">
                                                <AvField 
                                                    name="award_description"
                                                    placeholder="Deskripsi..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Deskripsi (4 digit)"
                                                    className="form-control"
                                                    id="award_description"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label htmlFor="fieldPejabat" className="col-md-3 col-form-label">File Pendukung</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col md="4"></Col>
                                            <Col md="8">
                                                <Link to="/kepegawaian/home.html?penghargaan">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>

                        </Col>               
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?penghargaan'/>
                : null }

            </Fragment>
        )
    }
}

export default CreateView